import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";

export default function Splash() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const t = setTimeout(() => {
      if (user) {
        if (["admin_master", "operador_evento", "comercial"].includes(user.role)) navigate("/admin/dashboard", { replace: true });
        else navigate("/home", { replace: true });
      } else {
        navigate("/login", { replace: true });
      }
    }, 1900);
    return () => clearTimeout(t);
  }, [user, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-hero-radial bg-white px-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, ease: [0.2, 0.8, 0.2, 1] }}
        data-testid="splash-logo"
      >
        <Logo size={64} />
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.25, duration: 0.4 }}
        className="mt-10 text-center font-display text-base sm:text-lg max-w-md text-[hsl(var(--primary))]"
        data-testid="splash-tagline"
      >
        Transformando gestores públicos em reais agentes de mudança.
      </motion.p>
      <div className="mt-12 flex gap-1.5">
        <span className="w-2 h-2 rounded-full bg-[hsl(var(--accent))] animate-bounce" />
        <span className="w-2 h-2 rounded-full bg-[hsl(var(--accent))] animate-bounce" style={{ animationDelay: "100ms" }} />
        <span className="w-2 h-2 rounded-full bg-[hsl(var(--accent))] animate-bounce" style={{ animationDelay: "200ms" }} />
      </div>
    </div>
  );
}
